import { defineMessages } from 'react-intl';

export default defineMessages({
  prompt: {
    id: 'kustomer.chat.form.mll.prompt',
    description: 'Header for MLL dropdown',
    defaultMessage: 'Please select an item',
  },
  submitBtn: {
    id: 'kustomer.chat.form.mll.submit',
    description: 'Copy for submit button',
    defaultMessage: 'Submit',
  },
  breadcrumbHome: {
    id: 'kustomer.chat.form.mll.breadcrumb.home',
    description: 'Copy for return to root of MLL',
    defaultMessage: 'Home',
  },
  inputPlaceholder: {
    id: 'kustomer.chat.form.mll.input.placeholder',
    description: 'Placeholder for MLL input',
    defaultMessage: 'Please select an item',
  },
  aria_label_breadcrumb: {
    id: 'kustomer.chat.form.mll.aria.label.breadcrumb.1',
    description: 'Aria label for breadcrumb',
    defaultMessage: '{displayName} breadcrumb',
  },
});
